const riot = require('riot');

riot.tag2('page-operators', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full f fclm p40 bg-gray_light_10"> <div class="f fm fbw mb20"> <div class="lh15 fs30 fw3">オペレーター管理</div> </div> <div class="s-full f fclm p20 bg-white overflow-hidden"> <form class="f fb mb48" onsubmit="{onInviteUser}"> <label class="block w-full"> <div class="lh12 fs16 fw5 mb24">オペレーターの招待</div> <input class="input w70per" ref="email" required placeholder="help@repro.io" type="email"> </label> <button class="flex-fixed button primary">メンバーを招待</button> </form> <div class="s-full f fclm overflow-hidden"> <div class="f fm border-bottom border-top border-gray_light_10 bg-primary_light_50 py10 px16"> <div class="w-full lh12 fw5 fs16">名前</div> <div class="w-full lh12 fw5 fs16">メールアドレス</div> </div> <div class="s-full overflow-scroll pb20"> <div class="relative f fm fbw h60 px16 border-bottom border-gray_light_10" each="{user in users}"> <div class="w-full word-break-all">{user.name}</div> <div class="w-full word-break-all">{user.email}</div> <div class="absolute r0 t0 b0 f fh px12 cursor-pointer" if="{user.id !== app.utils.auth.currentUser.id}" onclick="{onOpenActionSheet}"><i class="material-icons text-gray_dark_20">more_vert</i></div> </div> </div> </div> </div> </div> </div>', '', '', function(opts) {
    this.preload = async () => {
      if (spat.isNode) return;
      app.utils.auth.validateOperator();

      var params = {
        limit: 999,
        offset: 0,
        role: 'operator',
      };

      var {users} = await app.store.users.index(params);
      return {
        users,
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('オペレーター管理', this),
      };
    };

    this.onInviteUser = async (e) => {
      e.preventDefault();
      try {
        var email = this.refs.email.value;
        var indicator = spat.modal.indicator();

        var providers = await app.auth.fetchSignInMethodsForEmail(email);

        if (providers.length === 0) {
          var params = {
            email: this.refs.email.value,
            role: 'operator',
          };
          await app.api.child('users').post(params);

          var {users} = await app.store.users.index({limit: 999, offset: 0, role: 'operator'});
          this.users = users;
          this.refs.email.value = '';
          this.update();

          spat.modal.alert('招待しました');
        }
        else {
          spat.modal.alert('招待済みのユーザーです');
        }

      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.deleteUser = async (e) => {
      var modal = await spat.modal.open('modal-confirm', {
        text: '削除しますか？',
      });
      var result = await modal.waitClose();
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`users/${e.item.user.id}`).del();
        var {users} = await app.store.users.index({limit: 999, offset: 0, role: 'operator'});
        this.users = users;
        this.update();
        spat.modal.alert('メンバーを削除しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onOpenActionSheet = (e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "trash",
          label: "削除",
          action: () => { popup.close(); this.deleteUser(e); },
          alert: true,
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        position: 'bottom',
        opts: {
          options,
        }
      });
    };
});